import { render, staticRenderFns } from "./PublisherBlacklist.vue?vue&type=template&id=7472b168&scoped=true&"
import script from "./PublisherBlacklist.vue?vue&type=script&lang=js&"
export * from "./PublisherBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./PublisherBlacklist.vue?vue&type=style&index=0&id=7472b168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472b168",
  null
  
)

export default component.exports